/* stolvi storefront: hero slideshow, drawers (search + bag), qty stepper, ajax add to bag */
(() => {
  const S = window.svShop || { routes: {}, t: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- money ---------- */
  const money = cents => {
    const fmt = S.moneyFormat || '{{amount}}';
    const n = Number(cents) || 0;
    const fix = (v, d, t = ',', dec = '.') => {
      const [i, f] = (v / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? dec + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(n, 2), amount_no_decimals: fix(n, 0),
      amount_with_comma_separator: fix(n, 2, '.', ','), amount_no_decimals_with_comma_separator: fix(n, 0, '.', ','),
      amount_with_apostrophe_separator: fix(n, 2, "'", '.'), amount_with_space_separator: fix(n, 2, ' ', ',')
    }[k] ?? fix(n, 2))).replace(/<[^>]*>/g, '');
  };

  /* ---------- hero slideshow ---------- */
  const initHero = root => $$('[data-sv-hero]', root).forEach(hero => {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    const slides = $$('[data-sv-slide]', hero);
    const dots = $$('[data-sv-dot]', hero);
    const pause = $('[data-sv-pause]', hero);
    if (slides.length < 2) return;
    let i = 0, timer = null, paused = reduce || hero.dataset.autoplay !== 'true';
    const speed = Number(hero.dataset.speed) || 6000;
    const show = n => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        $$('a,button', s).forEach(el => on ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1'));
        const v = $('video', s);
        if (v) { if (on) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause(); }
      });
      dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      hero.style.setProperty('--sv-progress-dur', speed + 'ms');
      hero.classList.remove('is-ticking'); void hero.offsetWidth; if (!paused) hero.classList.add('is-ticking');
    };
    const start = () => { clearInterval(timer); if (!paused) timer = setInterval(() => show(i + 1), speed); };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
    pause && pause.addEventListener('click', () => {
      paused = !paused; pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      hero.classList.toggle('is-paused', paused); show(i); start();
    });
    if (paused && pause) { pause.setAttribute('aria-pressed', 'true'); hero.classList.add('is-paused'); }
    let x0 = null;
    hero.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) { show(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(timer) : start());
    show(0); start();
  });

  /* ---------- drawers ---------- */
  const overlay = $('[data-sv-overlay]');
  let openDrawer = null, lastFocus = null;
  const open = name => {
    const d = $(`[data-sv-drawer="${name}"]`); if (!d || !overlay) return false;
    if (openDrawer && openDrawer !== d) close(true);
    lastFocus = document.activeElement;
    d.hidden = false; overlay.hidden = false;
    requestAnimationFrame(() => { d.classList.add('is-open'); overlay.classList.add('is-open'); });
    document.documentElement.classList.add('sv-lock');
    openDrawer = d;
    setTimeout(() => { const f = name === 'search' ? $('[data-sv-search-input]', d) : $('[data-sv-close]', d); f && f.focus(); }, 60);
    return true;
  };
  const close = instant => {
    const d = openDrawer; if (!d) return;
    d.classList.remove('is-open'); overlay.classList.remove('is-open');
    document.documentElement.classList.remove('sv-lock');
    const done = () => { d.hidden = true; if (!openDrawer) overlay.hidden = true; };
    openDrawer = null;
    instant ? done() : setTimeout(done, 320);
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-sv-open]');
    if (opener) {
      if (opener.dataset.svOpen === 'cart' && location.pathname === S.routes.cart) return;
      if (open(opener.dataset.svOpen)) { e.preventDefault(); if (opener.dataset.svOpen === 'cart') renderCart(); }
      return;
    }
    if (e.target.closest('[data-sv-close]') || e.target === overlay) close();
    if (openDrawer && e.target.closest('.sv-drawer a[href]')) {
      const a = e.target.closest('a[href]');
      if (a.hash && a.pathname === location.pathname) close(true);
    }
  });
  document.addEventListener('keydown', e => {
    if (!openDrawer) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = $$('a[href],button:not([disabled]),input:not([type=hidden]),[tabindex]:not([tabindex="-1"])', openDrawer).filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- predictive search ---------- */
  const sInput = $('[data-sv-search-input]');
  if (sInput) {
    const results = $('[data-sv-results]');
    const quick = $('[data-sv-quick]');
    const clear = $('[data-sv-search-clear]');
    const foot = $('[data-sv-search-foot]');
    const form = sInput.form;
    let ctrl, t;
    const reset = () => { results.innerHTML = ''; quick.hidden = false; foot.hidden = true; clear.hidden = true; };
    const run = async q => {
      ctrl && ctrl.abort(); ctrl = new AbortController();
      try {
        const url = `${S.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor`;
        const r = await fetch(url, { signal: ctrl.signal }); const j = await r.json();
        const res = (j.resources && j.resources.results) || {};
        const qs = (res.queries || []).slice(0, 4), ps = res.products || [];
        let h = '';
        if (qs.length) h += `<p class="eyebrow">${esc(S.t.suggestions)}</p><ul class="sv-suggest">${qs.map(x => `<li><a href="${esc(x.url)}">${x.styled_text || esc(x.text)}</a></li>`).join('')}</ul>`;
        if (ps.length) h += `<p class="eyebrow">${esc(S.t.products)}</p><ul class="sv-presults">${ps.map(p => {
          const price = Math.round(parseFloat(p.price || 0) * 100);
          const th = (S.thumbs || {})[p.handle];
          const src = th || (p.featured_image && p.featured_image.url);
          const img = src ? `<img src="${esc(src)}${th ? '' : (src.includes('?') ? '&' : '?') + 'width=160'}" alt="" width="80" height="80" loading="lazy">` : '';
          return `<li><a href="${esc(p.url)}"><span class="sv-presults__img">${img}</span><span class="sv-presults__copy"><strong>${esc(p.title)}</strong>${price > 0 ? `<small>${esc(money(price))}</small>` : ''}</span><span aria-hidden="true">›</span></a></li>`;
        }).join('')}</ul>`;
        if (!qs.length && !ps.length) h = `<p class="sv-noresults">${esc(S.t.noResults)}</p>`;
        results.innerHTML = h; quick.hidden = true; foot.hidden = false;
      } catch (err) { if (err.name !== 'AbortError') reset(); }
    };
    sInput.addEventListener('input', () => {
      const q = sInput.value.trim(); clear.hidden = !q; clearTimeout(t);
      if (q.length < 1) return reset();
      t = setTimeout(() => run(q), 180);
    });
    clear.addEventListener('click', () => { sInput.value = ''; reset(); sInput.focus(); });
    $('[data-sv-search-all]').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  }

  /* ---------- bag ---------- */
  const setCount = n => {
    $$('#cart-toggle').forEach(a => { a.dataset.count = n > 0 ? n : ''; a.setAttribute('aria-label', (a.getAttribute('aria-label') || '').replace(/\(\d+\)/, `(${n})`)); });
    const c = $('[data-sv-cart-count]'); if (c) c.textContent = n > 0 ? `(${n})` : '';
  };
  const cartItems = $('[data-sv-cart-items]');
  const renderCart = async cart => {
    if (!cartItems) return;
    try { if (!cart) cart = await (await fetch(S.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { return; }
    setCount(cart.item_count);
    const foot = $('[data-sv-cart-foot]');
    $('[data-sv-cart-total]').textContent = money(cart.total_price);
    if (!cart.items.length) {
      cartItems.innerHTML = `<div class="sv-cart-empty"><p>${esc(S.t.empty)}</p><a class="sv-btn sv-btn--dark" href="${esc(S.routes.all)}">Shop now</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    const chev = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
    cartItems.innerHTML = cart.items.map((it, k) => {
      const th = (S.thumbs || {})[it.handle];
      const isrc = th || (it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=200' : '');
      const img = isrc ? `<img src="${esc(isrc)}" alt="" width="96" height="96" loading="lazy">` : '';
      const variant = it.variant_title && !/default title/i.test(it.variant_title) ? `<small>${esc(it.variant_title)}</small>` : '';
      return `<article class="sv-line" data-line="${k + 1}" data-key="${esc(it.key)}">
        <a class="sv-line__img" href="${esc(it.url)}">${img}</a>
        <div class="sv-line__info"><a class="sv-line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>${variant}
          <div class="sv-line__row"><div class="sv-qty sv-qty--sm"><button type="button" class="sv-qty__btn" data-sv-line-qty="${it.quantity - 1}" aria-label="-1">${chev('m14.5 6-6 6 6 6')}</button><span class="sv-qty__val" aria-label="${esc(S.t.qty)}">${it.quantity}</span><button type="button" class="sv-qty__btn" data-sv-line-qty="${it.quantity + 1}" aria-label="+1">${chev('m9.5 6 6 6-6 6')}</button></div>
          ${it.final_line_price > 0 ? `<strong class="sv-line__price">${esc(money(it.final_line_price))}</strong>` : ''}</div>
          <button type="button" class="sv-line__remove" data-sv-line-qty="0">${esc(S.t.remove)}</button>
        </div></article>`;
    }).join('');
  };
  cartItems && cartItems.addEventListener('click', async e => {
    const b = e.target.closest('[data-sv-line-qty]'); if (!b) return;
    const line = b.closest('[data-line]'); line.classList.add('is-busy');
    try {
      const r = await fetch(S.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.dataset.key, quantity: Math.max(0, Number(b.dataset.svLineQty)) }) });
      renderCart(await r.json());
    } catch (err) { line.classList.remove('is-busy'); }
  });

  /* ---------- product form: stepper, price label, ajax add ---------- */
  const initProduct = root => $$('.sv-product-form', root).forEach(form => {
    if (form.dataset.svReady) return; form.dataset.svReady = '1';
    const section = form.closest('[data-shop-product]') || document;
    const qty = $('[data-shop-quantity]', form);
    const add = $('[data-shop-add]', form);
    if (!qty || !add) return;
    const label = $('[data-sv-add-label]', add);
    const priceEl = $('[data-sv-add-price]', add);
    const err = $('[data-sv-form-error]', form);
    const minus = $('[data-sv-qty-minus]', form), plus = $('[data-sv-qty-plus]', form);
    const sticky = $('[data-sv-sticky]');
    const stickyAdd = sticky && $('[data-sv-sticky-add]', sticky);
    const stickyPrice = sticky && $('[data-sv-sticky-price]', sticky);
    const step = () => Number(qty.step) || 1;
    const clamp = v => { const min = Number(qty.min) || 1; const max = qty.max ? Number(qty.max) : Infinity; return Math.min(max, Math.max(min, v)); };
    const refresh = () => {
      const available = add.dataset.available ? add.dataset.available === 'true' : !add.disabled;
      const unit = Number(add.dataset.priceCents) || 0;
      const n = clamp(Number(qty.value) || 1);
      label.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
      if (priceEl) { priceEl.hidden = !(available && unit > 0); priceEl.textContent = ` · ${money(unit * n)}`; }
      if (stickyAdd) stickyAdd.disabled = !available;
      if (stickyPrice && unit > 0) stickyPrice.textContent = money(unit);
      minus.disabled = n <= (Number(qty.min) || 1);
      plus.disabled = qty.max ? n >= Number(qty.max) : false;
    };
    minus.addEventListener('click', () => { qty.value = clamp(Number(qty.value) - step()); refresh(); });
    plus.addEventListener('click', () => { qty.value = clamp(Number(qty.value) + step()); refresh(); });
    qty.addEventListener('change', () => { qty.value = clamp(Number(qty.value) || 1); refresh(); });
    qty.addEventListener('input', refresh);
    section.addEventListener('sv:update', refresh);
    refresh();

    form.addEventListener('submit', async e => {
      if (!window.fetch || !S.routes.cartAdd) return;
      e.preventDefault();
      if (add.disabled) return;
      err.hidden = true; add.classList.add('is-busy'); add.disabled = true;
      try {
        const r = await fetch(S.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || S.t.error);
        if (S.cartDrawer === false) { location.href = S.routes.cart; return; }
        const cart = await (await fetch(S.routes.cart + '.js')).json();
        renderCart(cart);
        const flag = $('[data-sv-added]'); if (flag) { flag.hidden = false; setTimeout(() => { flag.hidden = true; }, 4000); }
        open('cart');
      } catch (ex) {
        err.textContent = ex.message || S.t.error; err.hidden = false;
      } finally { add.classList.remove('is-busy'); add.disabled = false; refresh(); }
    });

    if (sticky && stickyAdd && 'IntersectionObserver' in window) {
      stickyAdd.addEventListener('click', () => { form.requestSubmit ? form.requestSubmit(add) : add.click(); });
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyAdd.tabIndex = show ? 0 : -1;
      });
      io.observe($('.sv-buy', form));
    }
  });

  /* ---------- shop: category pills scroll-spy ---------- */
  const initPills = () => {
    const nav = $('.template-collection .hx-pills'); if (!nav) return;
    const links = $$('a[href^="#"]', nav);
    const pairs = links.map(a => [a, document.getElementById(a.hash.slice(1))]).filter(([, t]) => t && t.id !== 'main');
    const all = links.find(a => !pairs.some(([l]) => l === a)) || links[0];
    const tick = () => {
      let cur = all; const mid = innerHeight * .45;
      pairs.forEach(([a, t]) => { if (t.getBoundingClientRect().top < mid) cur = a; });
      links.forEach(l => l.classList.toggle('is-active', l === cur));
    };
    addEventListener('scroll', () => requestAnimationFrame(tick), { passive: true }); tick();
  };

  /* ---------- tile reveal ---------- */
  const revealIO = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  const initReveal = root => $$('.sv-tiles', root).forEach(g => { if (revealIO) { g.classList.add('sv-will-reveal'); revealIO.observe(g); } });

  const run = root => { initHero(root); initProduct(root); initReveal(root); };
  run(document); initPills();
  document.addEventListener('shopify:section:load', e => run(e.target));
})();
